import { Pin, PinTheme } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { PinContext } from '../../contexts/pinContext';
import { pinSize } from '../../foundations/layout/pinDefault';
import { useSortPinComponents } from '../../hooks/useSortPinComponents';
import { PinThemeContextProvider } from '../../utils/pinTheme/PinThemeContext';
import { PinComponentSwitch } from '../PinComponentSwitch/PinComponentSwitch';
import { PinSwitchStatic } from './components/PinSwitchStatic';

export interface PinViewerStaticProps {
  pin: Pin;
  pinTheme?: PinTheme;
  isThumb?: boolean;
  width?: number;
  pinComponentsAreStatic?: boolean;
  className?: string;
}

export const PinViewerStatic: React.FC<PinViewerStaticProps> = ({
  pin,
  pinTheme,
  isThumb,
  width = 200,
  pinComponentsAreStatic = true,
  className,
}) => {
  const pinComponents = useSortPinComponents(pin.pinComponents);
  const scale = width / pinSize.width;

  return (
    <StyledPinWrapper
      style={{ width: `${width}px`, height: `${width * (pinSize.height / pinSize.width)}px` }}
      className={className}
    >
      <StyledPin style={{ transform: `scale(${scale})` }}>
        <PinContext.Provider value={pin}>
          <PinThemeContextProvider pinType={pin.type} pinTheme={pinTheme}>
            <PinSwitchStatic pin={pin} isThumb={isThumb}>
              {pinComponents.map((pinComponent) => {
                return (
                  <PinComponentSwitch
                    pin={pin}
                    key={pinComponent.id}
                    pinComponent={pinComponent}
                    editable={false}
                    active={false}
                    isThumb={isThumb}
                    isStatic={pinComponentsAreStatic}
                    scale={scale}
                  />
                );
              })}
            </PinSwitchStatic>
          </PinThemeContextProvider>
        </PinContext.Provider>
      </StyledPin>
    </StyledPinWrapper>
  );
};

const StyledPin = styled.div`
  width: ${pinSize.width}px;
  height: ${pinSize.height}px;
  transform-origin: left top;
  position: relative;
  overflow: hidden;
`;

const StyledPinWrapper = styled.div`
  pointer-events: none;
  position: relative;
`;
